import React, {useEffect} from 'react'
import './Homelove.css'
import Androidscreenshoot from '../images/Homelove/Androidscreenshoot.png'
import Artboard1 from '../images/Homelove/Artboard1.png'
import Artboard2 from '../images/Homelove/Artboard2.png'
import Artboard3 from '../images/Homelove/Artboard3.png'
import Artboard4 from '../images/Homelove/Artboard4.png'
import Artboard5 from '../images/Homelove/Artboard5.png'
import Artboard6 from '../images/Homelove/Artboard6.png'
import Artboard7 from '../images/Homelove/Artboard7.png'
import Artboard8 from '../images/Homelove/Artboard8.png'
import Artboard9 from '../images/Homelove/Artboard9.png'
import Artboard10 from '../images/Homelove/Artboard10.png'
import Footer from '../Component/footer'

function Homelove() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       

        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Homelove">
        <div className="client-role-Homelove">
            <h4 className="client-project-Homelove">CLIENT</h4>
            <h2 className="portfolio-heading-Homelove1"> Home Love</h2>
            <h4 className="role-Homelove">
            ROLE
            </h4>
            <h2 className="portfolio-role-Homelove2"> UI/UX Designer</h2>
           </div>
            <h4 className="client-details-Homelove"> DETAILS
            </h4>
            <p className="client-details-Homelove-p">
            Home Love stores can be found throughout USA, with a 
            representation in Namibia, Botswana, Mozambique and Ghana. 
            Eat, Sleep, Bath, Cook, Live - from the kitchen to the 
            bedroom, from spoiling yourself to giving beautiful gifts, 
            we have taken care to stock all that you need to create a 
            beautiful home. Our buying team travels the world sourcing 
            ranges and credible brands to inspire you, and is a reflection 
            of our passion for all things functional and innovative.
            </p>

            <p className="client-details-Homelove-p2">
            
            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
       
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}

export default Homelove
